import { ThemeEvents } from '@theme/events';

/**
 * Zone qui se met a jour quand le client change de variante (prix barre, economie, stock).
 * Le serveur renvoie la fiche produit mise a jour : on remplace le contenu de la zone
 * portant le meme data-block-id.
 */
class SxLive extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(ThemeEvents.variantUpdate, this.#onUpdate);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.#onUpdate);
  }

  #onUpdate = (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;
    const next = html.querySelector(`sx-live[data-block-id="${this.dataset.blockId}"]`);
    if (next) this.innerHTML = next.innerHTML;
  };
}

if (!customElements.get('sx-live')) customElements.define('sx-live', SxLive);
